import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b84614c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-container-toolbar" }
const _hoisted_2 = { class: "calendar-container-toolbar__first-row" }
const _hoisted_3 = { class: "calendar-container-toolbar__nav" }
const _hoisted_4 = { class: "calendar-container-toolbar__nav__label" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "calendar-container-toolbar__second-row"
}

import { FORMATS, SIZES } from '@/enums/components'
import { CalendarType } from '@/models/google.model'
import BaseButton from '@/components/BaseButton.vue'
import BaseSelect from '@/components/BaseSelect.vue'
import { add, sub } from 'date-fns'
import { computed, PropType } from 'vue'
import {
  getActualMonthDaysInMonthPeriod,
  getMonthDaysForDate,
  getWeekdaysForDate,
} from '@/utils/overview-calendar'
import {
  formatIntlDateNumeric,
  formatIntlDateOnly,
  formatIntlMonthAndYear,
} from '@/utils/formatters'
import { useI18n } from 'vue-i18n'
import { useBreakpoints } from '@/composables/useBreakpoints'
import BaseCheckbox from '@/components/BaseCheckbox.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarToolbar',
  props: {
  selectedCalendar: {
    type: String as PropType<CalendarType>,
    required: true,
  },
  days: {
    type: Array as PropType<Date[]>,
    default: () => [],
  },
  multidayEventsInTimeline: {
    type: Boolean,
    default: false,
  },
  canChangeCalendarType: {
    type: Boolean,
    default: true,
  },
  canEnableMultidayEventsInTimeline: {
    type: Boolean,
    default: true,
  },
},
  emits: [
  'onCalendarChange',
  'onDaysChange',
  'onMultidayEventsInTimelineChange',
],
  setup(__props, { emit }) {

const props = __props



const i18n = useI18n()
const { isMobile } = useBreakpoints()


const durationLabel = computed(() => {
  switch (props.selectedCalendar) {
    case CalendarType.DAY:
      return formatIntlDateOnly(props.days[0])
    case CalendarType.WEEK:
      return `${formatIntlDateNumeric(props.days[0])} - ${formatIntlDateNumeric(
        props.days[props.days.length - 1],
      )}`
    case CalendarType.MONTH:
      return formatIntlMonthAndYear(
        getActualMonthDaysInMonthPeriod(props.days)[0],
      )
    default:
      return ''
  }
})

const handleSelectCalendar = (calendarType: CalendarType) => {
  let newDays: Date[] = []
  const currentDate = new Date()
  switch (calendarType) {
    case CalendarType.DAY:
      if (
        currentDate.getTime() >= props.days[0].getTime() &&
        currentDate.getTime() <= props.days[props.days.length - 1].getTime()
      ) {
        newDays = [currentDate]
      } else {
        newDays = [props.days[0]]
      }
      break
    case CalendarType.WEEK:
      newDays = getWeekdaysForDate(props.days[0])
      break
    case CalendarType.MONTH:
      newDays = getMonthDaysForDate(props.days[0])
      break
  }
  emit('onCalendarChange', calendarType)
  emit('onDaysChange', newDays)
}

const handleSetToday = () => {
  let newDays: Date[] = []
  switch (props.selectedCalendar) {
    case CalendarType.DAY:
      newDays = [new Date()]
      break
    case CalendarType.WEEK:
      newDays = getWeekdaysForDate(new Date())
      break
    case CalendarType.MONTH:
      newDays = getMonthDaysForDate(new Date())
      break
  }
  emit('onDaysChange', newDays)
}

const handleNext = () => {
  let newDays: Date[] = []
  switch (props.selectedCalendar) {
    case CalendarType.DAY:
      newDays = [add(props.days[0], { days: 1 })]
      break
    case CalendarType.WEEK:
      newDays = getWeekdaysForDate(add(props.days[0], { weeks: 1 }))
      break
    case CalendarType.MONTH:
      newDays = getMonthDaysForDate(
        add(getActualMonthDaysInMonthPeriod(props.days)[0], { months: 1 }),
      )
      break
  }
  emit('onDaysChange', newDays)
}

const handleBack = () => {
  let newDays: Date[] = []
  switch (props.selectedCalendar) {
    case CalendarType.DAY:
      newDays = [sub(props.days[0], { days: 1 })]
      break
    case CalendarType.WEEK:
      newDays = getWeekdaysForDate(sub(props.days[0], { weeks: 1 }))
      break
    case CalendarType.MONTH:
      newDays = getMonthDaysForDate(
        sub(getActualMonthDaysInMonthPeriod(props.days)[0], { months: 1 }),
      )
      break
  }
  emit('onDaysChange', newDays)
}

const getOptionLabel = (option: CalendarType) => {
  switch (option) {
    case CalendarType.DAY:
      return i18n.t('overviewCalendar.day')
    case CalendarType.WEEK:
      return i18n.t('overviewCalendar.week')
    case CalendarType.MONTH:
      return i18n.t('overviewCalendar.month')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseButton, {
          type: "button",
          label: _ctx.$t('overviewCalendar.today'),
          format: _unref(FORMATS).SECONDARY,
          size: _unref(isMobile) ? _unref(SIZES).SMALL : _unref(SIZES).MEDIUM,
          onClick: handleSetToday
        }, null, 8, ["label", "format", "size"]),
        _createVNode(BaseButton, {
          format: _unref(FORMATS).ICON_CIRCULAR,
          size: _unref(SIZES).SMALL,
          "icon-size": _unref(isMobile) ? 16 : 24,
          type: "button",
          icon: 'chevron-down',
          class: "calendar-container-toolbar__nav__button--back",
          onClick: handleBack
        }, null, 8, ["format", "size", "icon-size"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", null, _toDisplayString(_unref(durationLabel)), 1)
        ]),
        _createVNode(BaseButton, {
          format: _unref(FORMATS).ICON_CIRCULAR,
          size: _unref(SIZES).SMALL,
          "icon-size": _unref(isMobile) ? 16 : 24,
          type: "button",
          icon: 'chevron-down',
          class: "calendar-container-toolbar__nav__button--next",
          onClick: handleNext
        }, null, 8, ["format", "size", "icon-size"])
      ]),
      (__props.canChangeCalendarType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(BaseSelect, {
              type: "select",
              options: Object.values(_unref(CalendarType)),
              "custom-label": getOptionLabel,
              "close-on-select": "",
              class: "calendar-container-toolbar__select",
              "model-value": __props.selectedCalendar,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => handleSelectCalendar(value))
            }, null, 8, ["options", "model-value"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.canEnableMultidayEventsInTimeline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(BaseCheckbox, {
            name: "show-multiday-events-in-timeline",
            "model-value": __props.multidayEventsInTimeline,
            label: _ctx.$t('overviewCalendar.multidayEventsInTimeline'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('onMultidayEventsInTimelineChange')))
          }, null, 8, ["model-value", "label"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})